import { Route } from "react-router-dom";
import Grading from "./custom-pages/grading";
import Locations from "./custom-pages/locations";
import IPSoybeans from "./custom-pages/ip-soybean";
const navItems = {
  nav: [
    {
      title: "Home",
      link: "/home",
      show: true,
    },
    {
      title: "Cash Bids",
      link: "/cashbids",
      show: true,
    },
    {
      title: "Futures",
      link: "/futures",
      show: true,
      external: false,
    },
    {
      title: "Grading",
      link: "/grading",
      show: true,
    },
    {
      title: "IP Soybean Program",
      link: "/ip-soybeans",
      show: true,
    },
    {
      title: "Locations",
      link: "/locations",
      show: true,
    },
    {
      title: "Weather",
      link: "/weather",
      show: true,
    },
  ],
  customNavRoute: [
    <Route key={"grading"} path="/grading" component={Grading}></Route>,
    <Route key={"location"} path="/locations" component={Locations}></Route>,
    <Route
      key={"ip-soybeans"}
      path="/ip-soybeans"
      component={IPSoybeans}
    ></Route>,
  ],
};

export default navItems;
